import PropTypes from 'prop-types';

import withTheme from 'core/hocs/withTheme';
import { SkeletonLoader } from 'core/components/Loader';

import styles from './index.styl';

function EmojiLoader({ theme }) {
  const reactionsAtoms = theme.controls.reactions;

  return (
    <div className={styles.reactions}>
      <style jsx>{`
        .${styles.content}
          padding ${reactionsAtoms.small.padding}
      `}</style>
      <style jsx>{`
        .skeleton
          height 18px
          width 18px
      `}</style>
      <div className={styles.content}>
        <div className='skeleton' />
      </div>
      <div className={styles.content}>
        <div className='skeleton' />
      </div>
      <div className={styles.content}>
        <div className='skeleton' />
      </div>
      <div className={styles.content}>
        <div className='skeleton' />
      </div>
    </div>
  );
}

EmojiLoader.propTypes = {
  theme: PropTypes.object,
};

const Skeleton = props => <SkeletonLoader skeleton={EmojiLoader} {...props} />;

export default withTheme(Skeleton);
